import {
    format as dateFormat,
    formatRelative,
    formatDistance as dateFormatDistance,
    parseISO,
    type Locale,
} from 'date-fns';
import { et, fi } from 'date-fns/locale';

type DateFormat = 'long' | string;

export function useDate() {
    const { $i18n } = useNuxtApp();
    const locale: Locale = $i18n.locale.value === 'et' ? et : fi;

    // eslint-disable-next-line unicorn/consistent-function-scoping
    const getDate = (date: Date | string) => (typeof date === 'string' ? parseISO(date) : date);

    const format = (date: Date | string, formatting: DateFormat) => {
        const localDate = getDate(date);

        if (formatting === 'relative') {
            return formatRelative(localDate, new Date(), { locale });
        }

        return dateFormat(localDate, formatting, { locale });
    };

    const formatDistance = (date: Date | string) => {
        const localDate = getDate(date);

        return dateFormatDistance(localDate, new Date(), { locale, addSuffix: true });
    };

    return {
        format,
        formatDistance,
    };
}
